import { useState } from "react";
import { Divider, Typography } from "antd";
import GenerateReport from "../../components/Report/DailyReport/GenerateReport";
import DownloadPdf from "../../components/Report/DailyReport/DownloadPdf";
import ViewReport from "../../components/Report/DailyReport/ViewReport";

const ReportPage = () => {

    const [reportData, setReportData] = useState();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const handleGetEolReport = (data) => {
        const updatedData = data.map((item, index) => ({
            "SNo": index + 1,
            ...item,
        }));
        setReportData(updatedData);
    };

    const handleGetDate = (startDate, endDate) => {
        setStartDate(startDate);
        setEndDate(endDate);

    };
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Daily Report
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />

            <GenerateReport handleGetEolReport={handleGetEolReport} handleGetDate={handleGetDate} />
            <ViewReport reportData={reportData}
                startDate={startDate}
                endDate={endDate} />
        </>
    );
};

export default ReportPage;